<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
import OperatorBreadcrumb from '@/components/operator/OperatorBreadcrumb.vue'
import {
  OperatorStepTreeDataQuery,
  OperatorStepTreeDataQueryVariables,
  StepTreeDataQuery,
} from '@/generated/graphql'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import OperatorStepTree from '@/components/operator/OperatorStepTree.vue'
import OperatorCurrentProductionBatch from '@/components/operator/OperatorCurrentProductionBatch.vue'
import useTree, { TreeItemNode } from '@/composables/useTree'
import OperatorModuleStepper from '@/components/operator/OperatorModuleStepper.vue'

export type OperatorModuleViewTreeNode = TreeItemNode<OperatorModuleViewNode>
export type OperatorModuleViewModule = StepTreeDataQuery['product']['module']
export type OperatorModuleViewNode = OperatorModuleViewModule['nodes'][0]
const route = useRoute()
const router = useRouter()

const bopId = computed(() => route.params.bopId as string)
const moduleId = computed(() => route.params.moduleId as string)
const stepId = computed(() => route.params.stepId as string | undefined)
const fetchQuery = useQuery<OperatorStepTreeDataQuery, OperatorStepTreeDataQueryVariables>(
  gql`
    query OperatorStepTreeData($moduleId: ID!) {
      product {
        module(id: $moduleId) {
          id
          abbreviation
          nodes {
            id
            parentId
            step {
              id
              name
              durationInSeconds
              stepType {
                id
                name
              }
            }
          }
        }
      }
    }
  `,
  () => ({
    moduleId: moduleId.value,
  }),
)

const abbreviation = computed(() => fetchQuery.result.value?.product.module.abbreviation || '')
const stepNodes = computed<OperatorModuleViewNode[]>(
  () => fetchQuery.result.value?.product.module.nodes || [],
)

// isSelected
const { treeRootNodes } = useTree()

const treeNodes = computed(() => treeRootNodes(stepNodes))

function selectStep(id: string | undefined) {
  router.push({ params: { stepId: id } })
}
</script>

<template>
  <operator-breadcrumb />
  <operator-current-production-batch :step-id="stepId" :module-id="moduleId" class="my-2" />

  <operator-module-stepper
    :bop-id="bopId"
    :module-id="moduleId"
    :step-id="stepId"
    :nodes="treeNodes"
    @select-step-id="selectStep"
  />
  <operator-step-tree
    :abbreviation="abbreviation"
    :nodes="treeNodes"
    :loading="fetchQuery.loading.value"
    :selected-step-id="stepId"
    @update:selected-step-id="selectStep"
  />
</template>

<style scoped lang="scss"></style>
